export enum SecondRemindBefore {
    OneHour = 1,
    TwoHours = 2,
    ThreeHours = 3
}